import { useId, useRef } from 'react';
import { input, label } from './adminUi';

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

function parseIsoDateForPicker(value) {
  if (!value || typeof value !== 'string') return '';
  const t = value.trim();
  return ISO_DATE.test(t) ? t : '';
}

/** News article date; value / onChange use YYYY-MM-DD. */
export default function PublicationDateField({ value, onChange }) {
  const id = useId();
  const inputRef = useRef(null);

  function openPicker() {
    const el = inputRef.current;
    if (!el) return;
    if (typeof el.showPicker === 'function') {
      try {
        el.showPicker();
      } catch {
        el.focus();
      }
    } else {
      el.focus();
    }
  }

  return (
    <div className="sm:col-span-2 rounded-xl border border-neutral-200/90 bg-white p-4 shadow-sm sm:p-5">
      <label className={label} htmlFor={id}>
        Publication date
      </label>
      <div
        className="mt-1.5 cursor-pointer rounded-lg"
        onClick={openPicker}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            openPicker();
          }
        }}
        role="presentation"
      >
        <input
          id={id}
          ref={inputRef}
          type="date"
          className={`${input} w-full cursor-pointer [color-scheme:light]`}
          value={parseIsoDateForPicker(value)}
          onChange={(e) => onChange(e.target.value)}
          onClick={(e) => {
            e.stopPropagation();
            openPicker();
          }}
        />
      </div>
      <span className="mt-2 block text-[11px] leading-relaxed text-neutral-500">
        Shown on Latest news and the article page. Stored as YYYY-MM-DD.
      </span>
    </div>
  );
}
